module.exports = __webpack_public_path__ + "c26ae3f4af290b03a60d83e12bfc14ec.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/5_E2.mp3
// module id = 62
// module chunks = 0